import { AnalysisStatus, DatasetData } from "./dataset";

export interface SaveAnalysisUserDatasetPayload {
  analysisId: string;
  datasets: {
    id: string;
    name: string;
    short_desc: string;
  }[];
}

export interface SaveAnalysisUserDatasetReponse {
  dataset_ids: string[];
}

export interface GetAnalysisResponse {
  id: string;
  status: AnalysisStatus;
}

export interface GetAnalyticResponse {
  id: string;
  result: DatasetData[];
}

export interface GetAnalyticDetailResponse {
  result: DatasetData[];
}
export interface GetAnalysisConfigurationListParams {
  per_page?: number;
  q?: string;
  sort_by?: string;
  order?: string;
  dataset_id_filter?: string;
}

export enum EAnalysisAggregationType {
  ROW = "row",
  SINGLE_ATTRIBUTE = "single"
}

export type AnalysisAggregationType =
  | EAnalysisAggregationType.ROW
  | EAnalysisAggregationType.SINGLE_ATTRIBUTE;

export type AggregationType = "none" | "single" | "multiple";
export type AggregationCalculationType =
  | "sum"
  | "count"
  | "avg"
  | "min"
  | "max";
export type SortDirection = "asc" | "desc";

export interface AnalysisSummaryParamsPayload {
  datasetId: string;
  analysisId?: string;
  method?: string; // Optional: transformation method (e.g., "pivot", "transpose")
  attribute?: string; // Optional: attribute to filter by Used for grouping; exclude grid/catchmentID
  calculation?: AggregationCalculationType | null; // Required if aggregation_type !== "none"
  filters?: string[] | null; // Optional: filter by attributes, e.g., ["attribute1", "attribute2"]
  sort_type: string; // Optional: sort direction
  sort_by?: string; // Optional: field name to sort by
  grid?: string[] | null;
  category?: string;
}

export enum AnalysisJobStatus {
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  QUEUED = "QUEUED",
  SUCCESS = "SUCCESS"
}

export enum AnalysisJobAreaInputType {
  CATCHMENT = "TYPE_MARKER",
  ADMIN = "TYPE_ADMINISTRATIVE_AREA"
}

export interface AnalysisJobItem {
  id: string;
  name: string;
  status: AnalysisJobStatus;
  created_by: string;
  created_at: string;
  expired_at: string;
  datasets: { id: string; name: string }[];
  input_type: string;
  output_type: string;
  estimated_time_secs?: number;
}

export enum TimeFilterValue {
  All = "all",
  Day = "day",
  Last7Days = "7d",
  Last1Month = "1m",
  Last3Months = "3m",
  Custom = "custom"
}
